// extracted by mini-css-extract-plugin
export default {"table_wrapper":"_3Hq-098WzmJV_whp1EBAbA","tableWrapper":"_3Hq-098WzmJV_whp1EBAbA","tableContent":"_1G88buaqTJBmlwNTLwofuu","table":"_2T6P-Zg2jNDEOA254qxVwI"};